import { render, staticRenderFns } from "./UnitSelector.vue?vue&type=template&id=fb2a5da2&scoped=true&lang=pug&"
import script from "./UnitSelector.vue?vue&type=script&lang=ts&"
export * from "./UnitSelector.vue?vue&type=script&lang=ts&"
import style0 from "./UnitSelector.vue?vue&type=style&index=0&id=fb2a5da2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2a5da2",
  null
  
)

export default component.exports